export default "__VITE_ASSET__CpgEPvft__"